// src/components/common/HelpTooltip.js
import React from 'react';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';

const HelpTooltip = ({ title, placement = 'top' }) => {
  return (
    <Tooltip
      title={<Typography variant="body2">{title}</Typography>}
      placement={placement}
      arrow
      sx={{ ml: 0.5 }}
    >
      <IconButton size="small" sx={{ color: '#666' }}>
        <HelpOutline fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default HelpTooltip;